<script lang="ts">
    import { Card, Col, Image } from "sveltestrap";
    import { BlogData } from '../../../../Data/Miscellaneous/Blog';
    import Link from 'svelte-link';
    import { blogdetail, href } from "../../../../utils/Constant/Constant";
    let imgPath:string = "/assets/images";
</script>
  
{#each BlogData as elem}
  <Col sm="6" xl="3" class="box-col-6 des-xl-50">
    <Card>
      <div class="blog-box blog-grid">
        <div class="blog-wrraper">
          <Link href={href}>
            <Image fluid class="top-radius-blog" src="{imgPath}/{elem.img}" />
          </Link>
        </div>
        <div class="blog-details-second">
          <div class="blog-post-date">
              <span class="blg-month">{'apr'}</span>
              <span class="blg-date">{'10'}</span>
          </div>
          <Link href={href}>
            <h6 class="blog-bottom-details">{'Perspiciatis unde omnis.'}</h6>
          </Link>
          <p>{blogdetail}</p>
          <div class="detail-footer"> 
            <ul class="sociyal-list">
              <li>
                <i class="fa fa-user-o"></i>{'Admin'}
              </li>
              <li>
                <i class="fa fa-comments-o"></i>{'5'}
              </li>
              <li>
                <i class="fa fa-thumbs-o-up"></i>{'2 like'}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Card>
  </Col>
{/each}
  